import {
  Backdrop,
  Box,
  Card,
  CardActionArea,
  CardContent,
  CircularProgress,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdvertVideos from "./AdvertVideos";
import { FlexBox } from "./FlexBox";
import Snackbar1 from "./Snaclbar";
import TimeandMoney from "./TimeandMoney";
import { getBidImageUrl, normalizeBidImageUrl, resetImageRetryState, retryImageLoad } from "../asset/js/retryImageLoad";
function Posts({ post, bid }) {
  const navigate = useNavigate();
  const openBid = () => navigate(`/showbid/${post.id}`);
  const [showSnack, setShowSnack] = useState(false);
  const [mes, setMes] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };
  const firstImage = String(post.images || "")
    .split(",")
    .map(normalizeBidImageUrl)
    .find(Boolean) || "";
  const isEnded = Number(post.deadline) <= Date.now();

  return (
    <Box sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, width: "100%", maxWidth: "100%", minWidth: 0, height: "100%", boxSizing: "border-box" }}>
      {showSnack && <Snackbar1 mes={"נוסף לרשימת המשאלות בהצלחה"} />}
      <Card
        onClick={openBid}
        onKeyDown={(event) => { if (event.target === event.currentTarget && (event.key === "Enter" || event.key === " ")) { event.preventDefault(); openBid(); } }}
        role="link"
        tabIndex={0}
        aria-label={`פתיחת מכרז: ${post.title}`}
        sx={{
          cursor: "pointer",
          position: "relative",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          height: "100%",
          boxSizing: "border-box",
          borderRadius: "20px",
          overflow: "hidden",
          border: "1px solid #E5EDF5",
          boxShadow: "0 10px 30px rgba(31, 78, 121, .10)",
          transition: "transform .2s ease, box-shadow .2s ease, border-color .2s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 18px 38px rgba(31, 78, 121, .16)",
            borderColor: "#C8DFF3",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            zIndex: 3,
            display: "flex",
            alignItems: "center",
            gap: 0.7,
            px: 1.05,
            py: 0.5,
            borderRadius: "999px",
            bgcolor: "rgba(255,255,255,.94)",
            border: "1px solid rgba(23,59,87,.12)",
            boxShadow: "0 5px 14px rgba(20,55,82,.14)",
          }}
        >
          <Box component="span" sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: isEnded ? "#D93838" : "#25A55F", boxShadow: `0 0 0 3px ${isEnded ? "rgba(217,56,56,.12)" : "rgba(37,165,95,.12)"}` }} />
          <Typography component="span" sx={{ fontFamily: "Assistant", fontWeight: 900, fontSize: 12.5, color: "#24485F", lineHeight: 1 }}>
            {isEnded ? "הסתיים" : "פעיל"}
          </Typography>
        </Box>
        <Box sx={{ color: "black" }}>
          <CardActionArea component="div" sx={{ display: "block", width: "100%", maxWidth: "100%", "& .MuiCardActionArea-focusHighlight": { backgroundColor: "transparent" } }}>
            {firstImage && (
              <Box>
                <img
                  src={getBidImageUrl(firstImage, "card")}
                  loading="lazy"
                  decoding="async"
                  onLoad={resetImageRetryState}
                  onError={retryImageLoad}
                  maxWidth="100%"
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "210px",
                    display: "block",
                    margin: "0px auto",
                    paddingLeft: "0px",
                    paddingRight: "0px",
                    textAlign: "center",
                  }}
                  alt="green iguana"
                />
              </Box>
            )}
            {!firstImage && post.video !== null && (
              <AdvertVideos
                width="100%"
                height="200px"
                style={{
                  margin: "0px auto",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  textAlign: "center",
                }}
                video={post.video.split(",")[0]}
              />
            )}
            {!firstImage && post.video === null && (
              <Box
                sx={{
                  fontFamily: `${process.env.REACT_APP_FONT}`,
                  background: "linear-gradient(135deg, #1E78C8 0%, #54A9EE 100%)",
                  height: "210px",
                  margin: "0px auto",
                  verticalAlign: "center",
                  paddingLeft: "0px",
                  paddingRight: "0px",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: `${process.env.REACT_APP_FONT}`,
                    color: "white",
                    fontWeight: 800,
                    fontSize: "2rem",
                    lineHeight: "210px",
                    textShadow: "0 5px 16px rgba(0,0,0,.2)",
                  }}
                >
                  Bidit
                </Typography>
              </Box>
            )}
            <CardContent sx={{ px: 2.25, pt: 2, pb: 1.5 }}>
              <FlexBox sx={{ fontFamily: `${process.env.REACT_APP_FONT}` }}>
                <Typography
                  variant="h6"
                  sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, color: "#183B56", fontSize: "1.08rem", lineHeight: 1.35 }}
                >
                  {post.title.substr(0, 17) + "..."}
                </Typography>
              </FlexBox>
              <Typography
                variant="p"
                sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#64748B", lineHeight: 1.55, display: "block", minHeight: "24px" }}
              >
                {post.extra}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Box>
        <TimeandMoney
          bid={bid}
          post={post}
          handleToggle={handleToggle}
          setShowSnack={setShowSnack}
          handleClose={handleClose}
          setMes={setMes}
        />
      </Card>
      <Backdrop
        sx={{
          fontFamily: `${process.env.REACT_APP_FONT}`,
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={open}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default Posts;
